import { UnstableFeatures } from "@core/hooks/use-unstable-features";
import { GiftKycAmc } from "creso-core/types";

export interface GiftAmc {
  name: string;
  enabled: boolean;
  /** Morningstar AMC code, used for the logo */
  ms_code: string;
  /** Matches `amc_code` on gift-city-form submissions */
  amc_code: string;
  /** Matches `amc_id` on folios */
  amc_id: number;
  /** AMC identifier sent to the gift KYC submission API */
  kyc_code?: GiftKycAmc;
  /** Only enabled for users with this unstable feature — see useGiftAmcs */
  unstableFeature?: keyof UnstableFeatures;

  minAmount: number;
  firstOrderMinAmount: number;
}

export const GIFT_AMCS: GiftAmc[] = [
  {
    ms_code: "0C0000A4JB",
    amc_code: "PPFAS_MF",
    name: "Parag Parikh",
    enabled: true,
    amc_id: 30,
    kyc_code: "PPFAS",
    minAmount: 500,
    firstOrderMinAmount: 500,
  },
  {
    ms_code: "0C00009534",
    amc_code: "HDFCMUTUALFUND_MF",
    name: "HDFC",
    enabled: true,
    amc_id: 13,
    kyc_code: "HDFC",
    minAmount: 500,
    firstOrderMinAmount: 5000,
  },
  {
    ms_code: "0C00009532",
    amc_code: "EDELWEISS_MF",
    name: "Edelweiss",
    enabled: false,
    amc_id: 11,
    minAmount: 500,
    firstOrderMinAmount: 5000,
  },
  {
    ms_code: "0C0000CX2H",
    amc_code: "DSP_MF",
    name: "DSP",
    enabled: false,
    amc_id: 10,
    minAmount: 500,
    firstOrderMinAmount: 5000,
  },
];
